import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectKitchenArea } from 'shared/selectors/jsonQuery';

export const KitchenAreaContainer: FC = () => {
  const { gte: valueMin = null, lte: valueMax = null } = useSelector(selectKitchenArea);

  const onChange = useFilterChangeCallback();

  const handleMinValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setKitchenAreaMin', arguments: [value] });
  });

  const handleMaxValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setKitchenAreaMax', arguments: [value] });
  });

  return (
    <InlineFilter width={100} label="Кухня" dataTestId="kitchenArea">
      <RangeInput
        min={1}
        max={9999}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={handleMinValueChange}
        onChangeMax={handleMaxValueChange}
      />
    </InlineFilter>
  );
};
